import React, { Component } from "react";
import "../../assets/css/RecipientList.css";
import { fire, auth } from "../../firebase/index";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import withAuthorization from "../../components/Authorization/withAuthorization";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  ExportCSVButton,
} from "react-bootstrap-table";
import { Button, Modal } from "react-bootstrap";
import TimeStamp from "react-timestamp";
import { ExportToCsv } from "export-to-csv";
import InviteMemberGuide from "../Tutorial/InviteMemberGuide";
import "../../routes/app";
import "../../assets/css/header.css";
import { style } from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";
import { confirmAlert } from "react-confirm-alert";
import SwitchBtn from "./SwitchBtn";
import InviteMember from "./InviteMember";
import DetailsButton from "./DetailsButton";
import AddToRecipientButton from "./AddToRecipientButton";
import { customLog } from "../../variables/Variables";
import ReactTooltip from "react-tooltip";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    memberTitle: "Member Management",
    memberEmailTitle: "Member Email",
    memberNameTitle: "Member Name",
    adminRightsTitle: "Has Admin Rights",
    memberDetailsTitle: "Member Details",
    memberStatusTitle: "Member Status",
    memberAddedTitle: "Added on",
    removeSelectedBtn: "Remove Selected",
    exportFileName: "eGeeTouch Member List export",
    exportTitle: "Export List",
    exportAllMember: "Export All Members",
    exportBtn: "Export",
    exportCSVTitle: "Export CSV",
    cancelBtn: "Cancel",
    resultTitle1: "Showing ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    errorMessageTitle:
      "Please delete some members as you have exceeded plan limits",
    errorNameTitle: "Name can not be the same as their current name.",
    errorEmptyTitle: "Name can not be empty.",
    errorCharacterLimitTitle: "Characters for name has exceeded the limit.",
    errorSameNameTitle:
      "Name can not be the same as the user's current name or another member's name.",
    successUpdateTitle: "Updated name successfully.",
    confirmRemoveTitle: "Confirm Remove",
    removeRecipientTitle: "Remove recipient?",
    confirmTitle: "Confirm",
    cancelTitle: "Cancel",
    InviteMemberGuide: "Invite Members",
    remarksTitle: "Remarks",
    addSuccess: "Users have been added successfully!",
    removeSuccess: "Users have been removed successfully!",
    addExist: "is already linked to a group!",
    addError: "Failed to add users. Please try again later.",
    searchPlaceholder: "Search",
    superAdminName: "Super Admin",
    adminName: "Admin",
    regularUserName: "Member (Non-admin)",
    usernameTip3:
      "An admin is a member assigned admin role by the super admin.",
    noDataTitle: "No data found",
  },
});

const buildMemberDeleteMessage = (rowKeys = [], members = []) => {
  const lines = [];
  let count = 0;

  for (let i = 0; i < members.length; i++) {
    const member = members[i];

    if (rowKeys.includes(member.memberEmail)) {
      const name = member.memberName || "-";
      const email = member.memberEmail || "-";

      lines.push(`${count + 1}. ${name} <${email}>`);
      count += 1;

      if (count === 5) break;
    }
  }

  const total = rowKeys.length;

  return (
    <div>
      <div>
        You are about to remove <strong>{total}</strong> selected member
        {total > 1 ? "s" : ""}.
      </div>

      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}

        {total > 5 && (
          <div style={{ marginTop: "8px", fontStyle: "italic" }}>
            ...and {total - 5} more.
          </div>
        )}
      </div>

      <div>{localizationStrings.removeRecipientTitle}</div>
    </div>
  );
};

const confirmRemove = (next, rowKeys, members = []) => {
  confirmAlert({
    title: `${localizationStrings.confirmRemoveTitle} (${rowKeys.length})`,
    message: buildMemberDeleteMessage(rowKeys, members),
    buttons: [
      {
        label: localizationStrings.confirmTitle,
        onClick: () => next(),
      },
      {
        label: localizationStrings.cancelTitle,
      },
    ],
  });
};

class MemberManagement extends Component {
  state = {
    membersArr: [],
    exportMembersArr: [],
    loading: true,
    isLoading: false,
    isSuperAdmin: false,
    isAdmin: false,
    superAdminID: "",
    superAdminId: "",
    superAdminEmail: "",
    currentLanguage: "en",
    errorMessage: "",
    showPopup: false,
    showExportPopup: false,
    popupTitle: "",
    popupImage: [],
    selectedMembers: [],
    _notificationSystem: null,
  };

  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    if (!auth.currentUser) return;

    fire
      .database()
      .ref(`userSettings/${auth.currentUser.uid}/language`)
      .on("value", (snapshot) => {
        this.setState({ currentLanguage: snapshot.val() || "en" });
      });

    await this.initializePage();
  }

  componentWillUnmount() {
    if (auth.currentUser) {
      fire
        .database()
        .ref(`userSettings/${auth.currentUser.uid}/language`)
        .off();
    }
  }

  initializePage = async () => {
    this.setState({ loading: true });

    try {
      const superAdminID = await this.findCurrentUserGroup();
      if (!superAdminID) {
        this.setState({ loading: false, membersArr: [] });
        return;
      }

      await this.checkNameData(superAdminID);
      await this.getUserGroupData(superAdminID);
    } catch (error) {
      console.error(error);
      this.showNotification("Failed to load member data", "error", "tc", 5);
    } finally {
      this.setState({ loading: false });
    }
  };

  findCurrentUserGroup = async () => {
    const snapshot = await fire
      .database()
      .ref("groupAccounts")
      .once("value");
    if (!snapshot.exists()) return null;

    let matchedSuperAdminID = null;

    snapshot.forEach((superAdminSnap) => {
      const members = superAdminSnap.val()?.members || {};
      Object.values(members).forEach((member) => {
        if (member.memberEmail === auth.currentUser.email) {
          matchedSuperAdminID = superAdminSnap.key;
          this.setState({
            isAdmin: !!member.isAdmin,
            isSuperAdmin: !!member.isSuperAdmin,
            superAdminID: superAdminSnap.key,
            superAdminId: superAdminSnap.key,
          });
        }
      });
    });

    return matchedSuperAdminID;
  };

  checkNameData = async (superAdminID) => {
    const membersRef = fire
      .database()
      .ref(`groupAccounts/${superAdminID}/members`);
    const membersSnap = await membersRef.once("value");
    if (!membersSnap.exists()) return;

    const updates = [];

    membersSnap.forEach((childMember) => {
      const member = childMember.val();
      if (!member.memberName && member.memberEmail) {
        updates.push(
          this.getUserId(member.memberEmail).then(async (userUid) => {
            if (!userUid) return;
            const registeredMember = await fire
              .database()
              .ref(`registeredIndustrialUsersOnPlatform/${userUid}`)
              .once("value");

            const name = registeredMember.val()?.name;
            if (name) {
              return membersRef
                .child(childMember.key)
                .update({ memberName: name });
            }
          }),
        );
      }
    });

    await Promise.all(updates);
  };

  getUserId = async (email) => {
    const url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail";

    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ email }),
    });

    const result = await response.json();
    return result.uid || "";
  };

  getUserGroupData = async (superAdminID) => {
    const membersRef = fire
      .database()
      .ref(`groupAccounts/${superAdminID}/members`);
    const groupRef = fire.database().ref(`groupAccounts/${superAdminID}`);

    const [membersSnap, groupSnap] = await Promise.all([
      membersRef.once("value"),
      groupRef.once("value"),
    ]);

    const membersArr = [];
    const exportMembersArr = [];
    let superAdminEmail = "";

    membersSnap.forEach((memberSnap) => {
      const member = memberSnap.val();
      membersArr.push(member);

      exportMembersArr.push({
        memberName: member.memberName || "",
        memberEmail: member.memberEmail || "",
        status: member.isSuperAdmin
          ? localizationStrings.superAdminName
          : member.isAdmin
          ? localizationStrings.adminName
          : localizationStrings.regularUserName,
        memberAddedOn: this.dateTimeFormatCSV(member.memberAddedOn),
      });

      if (member.isSuperAdmin) {
        superAdminEmail = member.memberEmail;
      }
    });

    const maxUserLimit = groupSnap.val()?.payment?.maxUsers || 0;
    const errorMessage =
      membersArr.length > maxUserLimit
        ? localizationStrings.errorMessageTitle
        : "";

    this.setState({
      membersArr,
      exportMembersArr,
      superAdminEmail,
      superAdminId: superAdminID,
      superAdminID,
      errorMessage,
    });
  };

  deleteMemberByEmail = async (superAdmin, email) => {
    const db = fire.database();
    const deleteTasks = [];
    let memberName = "";

    // ── 1. groupAccounts / members ───────────────────────────────────────────
    const membersSnap = await db
      .ref(`groupAccounts/${superAdmin}/members`)
      .once("value");

    membersSnap.forEach((snap) => {
      const val = snap.val();
      if (val.memberEmail === email) {
        memberName = val.memberName || "";
        deleteTasks.push(
          db.ref(`groupAccounts/${superAdmin}/members/${snap.key}`).remove(),
        );
      }
    });

    // ── 2. groupAccounts / userGroups ────────────────────────────────────────
    const userGroupsSnap = await db
      .ref(`groupAccounts/${superAdmin}/userGroups`)
      .once("value");

    userGroupsSnap.forEach((snap) => {
      if (snap.val()?.memberEmail === email) {
        deleteTasks.push(
          db
            .ref(`groupAccounts/${superAdmin}/userGroups/${snap.key}`)
            .remove(),
        );
      }
    });

    // ── 3. retractableSharingRegistry ────────────────────────────────────────
    const retractSnap = await db
      .ref(`retractableSharingRegistry/${auth.currentUser.uid}`)
      .once("value");

    retractSnap.forEach((snap) => {
      if (snap.val()?.sharedToEmail === email) {
        deleteTasks.push(
          db
            .ref(
              `retractableSharingRegistry/${auth.currentUser.uid}/${snap.key}`,
            )
            .remove(),
        );
      }
    });

    // ── 4. userFriendListIndustrial ──────────────────────────────────────────
    const friendListIndustrialSnap = await db
      .ref(`userFriendListIndustrial/${auth.currentUser.uid}`)
      .once("value");

    friendListIndustrialSnap.forEach((snap) => {
      if (snap.val()?.friendEmail === email) {
        deleteTasks.push(
          db
            .ref(
              `userFriendListIndustrial/${auth.currentUser.uid}/${snap.key}`,
            )
            .remove(),
        );
      }
    });

    // ── 5. userFriendList ────────────────────────────────────────────────────
    const friendListSnap = await db
      .ref(`userFriendList/${auth.currentUser.uid}`)
      .once("value");

    if (friendListSnap.exists()) {
      const flatList = friendListSnap.val();
      Object.entries(flatList).forEach(([key, value]) => {
        if (value === email) {
          deleteTasks.push(
            db
              .ref(`userFriendList/${auth.currentUser.uid}/${key}`)
              .remove(),
          );
        }
      });
    }

    // ── 6. GroupManagement ───────────────────────────────────────────────────
    const groupMgmtSnap = await db
      .ref(`GroupManagement/${superAdmin}/${auth.currentUser.uid}`)
      .once("value");

    if (groupMgmtSnap.exists()) {
      groupMgmtSnap.forEach((groupSnap) => {
        const groupMembers = groupSnap.val()?.groupMembers || {};
        Object.entries(groupMembers).forEach(([memberKey, memberVal]) => {
          if (memberVal?.memberEmail === email) {
            deleteTasks.push(
              db
                .ref(
                  `GroupManagement/${superAdmin}/${auth.currentUser.uid}/${groupSnap.key}/groupMembers/${memberKey}`,
                )
                .remove(),
            );
          }
        });
      });
    }

    // ── 7. userLocks ─────────────────────────────────────────────────────────
    const registeredUsersSnap = await db
      .ref("registeredUsersOnPlatform")
      .once("value");

    let memberUid = null;

    registeredUsersSnap.forEach((child) => {
      if (
        typeof child.val() === "string" &&
        child.val().toLowerCase() === email.toLowerCase()
      ) {
        memberUid = child.key;
      }
    });

    if (memberUid) {
      const lockSnap = await db.ref(`userLocks/${memberUid}`).once("value");
      if (lockSnap.exists()) {
        deleteTasks.push(db.ref(`userLocks/${memberUid}`).remove());
      }
    }

    // ── Execute all deletions in parallel ────────────────────────────────────
    await Promise.all(deleteTasks);

    return { memberEmail: email, memberName };
  };

  onAfterDeleteRow = async (rowKeys) => {
    const superAdmin = this.state.superAdminId;
    if (!superAdmin || !rowKeys.length) return;

    this.setState({ isLoading: true });

    try {
      const removedMembers = await Promise.all(
        rowKeys.map((email) => this.deleteMemberByEmail(superAdmin, email)),
      );

      const activityLogsDB = fire
        .database()
        .ref("individualActivities")
        .child(superAdmin);

      const activityKey = activityLogsDB.push().key;

      const isBulk = removedMembers.length > 1;
      const firstMember = removedMembers[0] || {};

      await activityLogsDB.child(activityKey).set({
        activityType: isBulk ? 19 : 9,
        description: isBulk
          ? `${removedMembers.length} members removed in bulk`
          : "Member has been removed",

        detailedDescription: isBulk
          ? removedMembers
              .map((m) => `${m.memberName || ""} <${m.memberEmail || ""}>`)
              .join(", ")
          : "",

        memberEmail: isBulk ? "" : firstMember.memberEmail || "",
        memberName: isBulk ? "" : firstMember.memberName || "",

        removedMembers: isBulk ? removedMembers : [],

        userUid: auth.currentUser.uid,
        userEmail: auth.currentUser.email,
        snapKey: activityKey,
        platform: "Web App",
        timeStamp: Date.now(),
      });

      await this.getUserGroupData(superAdmin);

      this.setState({ selectedMembers: [] });

      this.showNotification(
        localizationStrings.removeSuccess,
        "success",
        "tc",
        5,
      );
    } catch (error) {
      console.error(error);
      this.showNotification("Error while deleting members", "error", "tc", 5);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  saveCellChanges = async (row, column, newValue) => {
    const recipientEmail = row.memberEmail;
    const sanitizedValue = String(newValue)
      .trim()
      .replace(/[^a-zA-Z0-9_]/g, "");

    if (!sanitizedValue) {
      this.showNotification(
        localizationStrings.errorEmptyTitle,
        "error",
        "tc",
        3,
      );
      return this.getUserGroupData(this.state.superAdminID);
    }

    if (sanitizedValue.length > 60) {
      this.showNotification(
        localizationStrings.errorCharacterLimitTitle,
        "error",
        "tc",
        3,
      );
      return this.getUserGroupData(this.state.superAdminID);
    }

    const membersSnap = await fire
      .database()
      .ref(`groupAccounts/${this.state.superAdminID}/members`)
      .once("value");

    let memberKey = "";
    let currentName = "";
    let duplicateFound = false;

    membersSnap.forEach((member) => {
      const val = member.val();
      if (val.memberEmail === recipientEmail) {
        memberKey = member.key;
        currentName = val.memberName || "";
      } else if (val.memberName === sanitizedValue) {
        duplicateFound = true;
      }
    });

    if (sanitizedValue === currentName) {
      this.showNotification(
        localizationStrings.errorNameTitle,
        "error",
        "tc",
        3,
      );
      return;
    }

    if (duplicateFound) {
      this.showNotification(
        localizationStrings.errorSameNameTitle,
        "error",
        "tc",
        3,
      );
      return this.getUserGroupData(this.state.superAdminID);
    }

    await fire
      .database()
      .ref(`groupAccounts/${this.state.superAdminID}/members/${memberKey}`)
      .update({ memberName: sanitizedValue });

    this.showNotification(
      localizationStrings.successUpdateTitle,
      "success",
      "tc",
      3,
    );
    this.getUserGroupData(this.state.superAdminID);
  };

  showNotification = (msg, lvl, position, duration, allowDismiss = false) => {
    if (!this.state._notificationSystem) return;

    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        />
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position,
      autoDismiss: duration,
      dismissible: allowDismiss,
    });
  };

  dateTimeFormatCSV = (time) => {
    if (!time) return "";
    const normalized = time < 1e12 ? time * 1000 : time;

    if (localizationStrings.getLanguage() === "ja") {
      const date = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }).format(normalized);

      const clock = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(normalized);

      return `${date} ${clock}`;
    }

    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(normalized);
  };

  handleExportCSV = () => {
    const csvData = this.state.membersArr.map((member) => ({
      [localizationStrings.memberNameTitle]: member.memberName || "",
      [localizationStrings.memberEmailTitle]: member.memberEmail || "",
      [localizationStrings.memberStatusTitle]: member.isSuperAdmin
        ? localizationStrings.superAdminName
        : member.isAdmin
        ? localizationStrings.adminName
        : localizationStrings.regularUserName,
      [localizationStrings.memberAddedTitle]: this.dateTimeFormatCSV(
        member.memberAddedOn,
      ),
    }));

    if (!csvData.length) {
      return this.showNotification("No data available", "error", "tc", 5);
    }

    const csvExporter = new ExportToCsv({
      filename: localizationStrings.exportFileName,
      fieldSeparator: ",",
      quoteStrings: false,
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      title: localizationStrings.exportTitle,
      useTextFile: false,
      useBom: true,
      headers: [
        localizationStrings.memberNameTitle,
        localizationStrings.memberEmailTitle,
        localizationStrings.memberStatusTitle,
        localizationStrings.memberAddedTitle,
      ],
    });

    csvExporter.generateCsv(csvData);
    this.setState({ showExportPopup: false });
  };

  createCustomDeleteButton = (onBtnClick) => (
    <Button
      bsSize="large"
      id="membermanageDeleteBtn"
      onClick={onBtnClick}
      style={{ marginTop: "10px" }}
      disabled={!this.state.selectedMembers.length}
    >
      <i className="far fa-trash-alt" /> {localizationStrings.removeSelectedBtn}
    </Button>
  );

  createCustomExportCSVButton = (onClick) => (
    <ExportCSVButton
      btnText={localizationStrings.exportCSVTitle}
      className="exportCSVBtn"
      onClick={() => this.setState({ showExportPopup: true })}
    />
  );

  createCustomSearchField = () => (
    <SearchField
      className="searchBar"
      placeholder={localizationStrings.searchPlaceholder}
    />
  );

  renderToggleBtn = (cell, row) => {
    const isSuperAdmin = this.state.superAdminEmail === row.memberEmail;

    return (
      <SwitchBtn
        hasAdminRights={{
          isAdmin: row.isAdmin,
          userEmail: row.memberEmail,
          superAdminID: this.state.superAdminId,
          isSuperAdmin,
        }}
      />
    );
  };

  renderDetailsBtn = (cell, row) => (
    <DetailsButton cellValue={cell} rowValue={row} memberName={row.memberName}>
      Info
    </DetailsButton>
  );

  renderAddToRecipient = (cell, row) => <AddToRecipientButton data={row} />;

  handlePopupOpen = () => {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.InviteMemberGuide,
      popupImage: [<InviteMemberGuide />],
    });
  };

  handlePopupClose = () => this.setState({ showPopup: false });

  render() {
    localizationStrings.setLanguage(this.state.currentLanguage || "en");

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      afterDeleteRow: this.onAfterDeleteRow,
      handleConfirmDeleteRow: (next, rowKeys) =>
        confirmRemove(next, rowKeys, this.state.membersArr),
      page: 1,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "All", value: this.state.membersArr.length || 1 },
      ],
      sizePerPage: 10,
      paginationShowsTotal: customTotal,
      deleteBtn: this.createCustomDeleteButton,
      searchField: this.createCustomSearchField,
      exportCSVBtn: this.createCustomExportCSVButton,
      noDataText: this.state.loading ? <Loading /> : <NoDataFound />,
    };

    const selectRowPropForSuperAdmin = {
      bgColor: "#eeeeee",
      unselectable: [this.state.superAdminEmail],
      mode: "checkbox",
      clickToSelect: true,
      selected: this.state.selectedMembers,
      onSelect: (row, isSelected) => {
        const next = isSelected
          ? [...this.state.selectedMembers, row.memberEmail]
          : this.state.selectedMembers.filter((x) => x !== row.memberEmail);

        this.setState({ selectedMembers: [...new Set(next)] });
      },
      onSelectAll: (isSelected, rows) => {
        const pageEmails = rows
          .map((row) => row.memberEmail)
          .filter((email) => email !== this.state.superAdminEmail);

        const next = isSelected
          ? [...new Set([...this.state.selectedMembers, ...pageEmails])]
          : this.state.selectedMembers.filter(
              (email) => !pageEmails.includes(email),
            );

        this.setState({ selectedMembers: next });
      },
    };

    const cellEditProp = {
      mode: "dbclick",
      blurToSave: true,
      afterSaveCell: this.saveCellChanges,
    };

    if (this.state.loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <NotificationSystem ref="notificationSystem" style={style} />
          <Loading />
        </div>
      );
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />

        <div
          className="header containers"
          style={{ maxWidth: "95%", margin: "auto" }}
        >
          <span className="text-danger">{this.state.errorMessage}</span>

          {this.state.isSuperAdmin ? (
            <BootstrapTable
              id="table"
              pagination
              bordered={false}
              data={this.state.membersArr}
              selectRow={selectRowPropForSuperAdmin}
              deleteRow
              options={options}
              search
              exportCSV
              cellEdit={cellEditProp}
            >
              <TableHeaderColumn dataSort dataField="memberName" editable>
                {localizationStrings.memberNameTitle}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataSort
                dataField="memberEmail"
                isKey
                editable={false}
              >
                {localizationStrings.memberEmailTitle}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataSort
                dataField="isAdmin"
                dataFormat={this.renderToggleBtn}
                editable={false}
              >
                {localizationStrings.adminRightsTitle}
                <a data-tip data-for="usernameTip3">
                  <span
                    style={{
                      color: "#3C3E41",
                      fontSize: "17px",
                      marginLeft: "10px",
                    }}
                    className="glyphicon glyphicon-info-sign"
                    aria-hidden="true"
                  />
                </a>
                <ReactTooltip id="usernameTip3" effect="solid">
                  <span>{localizationStrings.usernameTip3}</span>
                </ReactTooltip>
              </TableHeaderColumn>

              <TableHeaderColumn
                dataSort
                dataField="isAdmin"
                dataFormat={this.renderDetailsBtn}
                editable={false}
              >
                {localizationStrings.memberDetailsTitle}
              </TableHeaderColumn>
            </BootstrapTable>
          ) : (
            <BootstrapTable
              id="table"
              pagination
              bordered={false}
              data={this.state.membersArr}
              options={options}
              search
            >
              <TableHeaderColumn
                dataSort
                dataField="memberName"
                editable={false}
              >
                {localizationStrings.memberNameTitle}
              </TableHeaderColumn>

              <TableHeaderColumn dataSort dataField="memberEmail" isKey>
                {localizationStrings.memberEmailTitle}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataSort
                dataField="memberEmail"
                dataFormat={this.renderAddToRecipient}
                editable={false}
              >
                {localizationStrings.remarksTitle}
              </TableHeaderColumn>
            </BootstrapTable>
          )}

          {this.state.isSuperAdmin && (
            <InviteMember
              numOfUsersDeleted={0}
              dataCallBack={this.updateTable}
            />
          )}

          <Modal
            show={this.state.showPopup}
            onHide={this.handlePopupClose}
            dialogClassName="modal-90w"
          >
            <Modal.Header closeButton>
              <Modal.Title>{this.state.popupTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.state.popupImage}</Modal.Body>
          </Modal>

          <Modal
            show={this.state.showExportPopup}
            onHide={() => this.setState({ showExportPopup: false })}
            dialogClassName="modal-70w"
          >
            <Modal.Header closeButton>
              <Modal.Title>{localizationStrings.exportAllMember}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <BootstrapTable
                data={this.state.exportMembersArr}
                bordered={false}
                pagination
                options={{ sizePerPage: 10, hideSizePerPage: true }}
              >
                <TableHeaderColumn dataField="memberName" dataSort>
                  {localizationStrings.memberNameTitle}
                </TableHeaderColumn>
                <TableHeaderColumn dataField="memberEmail" isKey dataSort>
                  {localizationStrings.memberEmailTitle}
                </TableHeaderColumn>
                <TableHeaderColumn dataField="status" dataSort>
                  {localizationStrings.memberStatusTitle}
                </TableHeaderColumn>
                <TableHeaderColumn dataField="memberAddedOn" dataSort>
                  {localizationStrings.memberAddedTitle}
                </TableHeaderColumn>
              </BootstrapTable>

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button className="exportButton" onClick={this.handleExportCSV}>
                  {localizationStrings.exportBtn}
                </button>
                <button
                  className="cancelButton"
                  onClick={() => this.setState({ showExportPopup: false })}
                >
                  {localizationStrings.cancelBtn}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }

  updateTable = (callback) => {
    const existingMembers = callback.existingMembers || [];
    const totalNumOfSubmission = callback.totalLengthOfMembers || 0;

    if (callback.status === true) {
      if (totalNumOfSubmission !== existingMembers.length) {
        this.showNotification(
          localizationStrings.addSuccess,
          "success",
          "tc",
          5,
        );
      }

      existingMembers.forEach((member) => {
        this.showNotification(
          `${member} ${localizationStrings.addExist}`,
          "error",
          "tc",
          5,
        );
      });
    } else {
      this.showNotification(localizationStrings.addError, "error", "tc", 5);
    }

    this.getUserGroupData(this.state.superAdminID);
  };
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(MemberManagement);